import React from 'react';
import loadable from '@loadable/component';

const Spacer = () => (
	<div style={{ display: 'block', width: 36, height: 32 }} />
);
const loadableOpts = { fallback: <Spacer /> };

const ArtsAndCrafts = loadable(() => import('./ArtsAndCrafts'), loadableOpts);
const Beauty = loadable(() => import('./Beauty'), loadableOpts);
const Books = loadable(() => import('./Books'), loadableOpts);
const Fitness = loadable(() => import('./Fitness'), loadableOpts);
const FoodAndBeverage = loadable(() => import('./FoodAndBeverage'), loadableOpts);
const GeekAndGaming = loadable(() => import('./GeekAndGaming'), loadableOpts);
const Home = loadable(() => import('./Home'), loadableOpts);
const Kids = loadable(() => import('./Kids'), loadableOpts);
const Men = loadable(() => import('./Men'), loadableOpts);
const Novelty = loadable(() => import('./Novelty'), loadableOpts);
const Pets = loadable(() => import('./Pets'), loadableOpts);
const Spiritual = loadable(() => import('./Spiritual'), loadableOpts);
const Women = loadable(() => import('./Women'), loadableOpts);

export default {
	ArtsAndCrafts,
	Beauty,
	Books,
	Fitness,
	FoodAndBeverage,
	GeekAndGaming,
	Home,
	Kids,
	Men,
	Novelty,
	Pets,
	Spiritual,
	Women,
};
